import cc from "classcat";
import styles from "./StatusTimeline.module.css";

interface StatusCardProps {
  title: string;
  description: string;
}

function StatusCard({ title, description }: StatusCardProps) {
  return (
    <div className={cc([styles.card, styles.cardSecondary, styles.statusCard])}>
      <div className={styles.statusCardContent}>
        <div className={styles.statusCardIcon}>
          <i className={cc(["narmi-icon-check", styles.checkIcon])} />
        </div>
        <div className={styles.statusCardText}>
          <div className={styles.cardTitle}>{title}</div>
          <div className={styles.cardDescription}>{description}</div>
        </div>
      </div>
    </div>
  );
}

export { StatusCard };
